// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExportOutlinedSvg from "@fishx/icons-svg/es/asn/FileExportOutlined";
import FishxIcon from '../components/FishxIcon';

var FileExportOutlined = function FileExportOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExportOutlinedSvg
  }));
};

FileExportOutlined.displayName = 'FileExportOutlined';
export default React.forwardRef(FileExportOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileExportOutlined.js
// module id = 2699
// module chunks = 0